import { connect, MapStateToProps } from 'react-redux';
import { Props } from './ProfileHeroMobile';
import { AppState } from '../../../../types/store';
import { getCoverDeviation } from '../../../selectors/deviations';
import {
  getProfileOwnerUser,
  getProfileOwnerStats,
  getProfileOwnerTagline,
  getIsGroupProfile,
  getCanCustomizePage,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';

export type StateProps = Pick<
  Props,
  | 'coverDeviation'
  | 'profileOwnerUser'
  | 'isAuthorizedToCustomize'
  | 'isOwner'
  | 'isGroup'
  | 'tagline'
  | 'stats'
>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const coverDeviation = getCoverDeviation(state);
  const profileOwnerUser = getProfileOwnerUser(state);
  const tagline = getProfileOwnerTagline(state);
  const stats = getProfileOwnerStats(state);
  const isOwner = isCurrentUserProfileOwner(state);
  const isGroup = getIsGroupProfile(state);
  const isAuthorizedToCustomize = getCanCustomizePage(state);
  return {
    stats,
    isOwner,
    isGroup,
    tagline,
    coverDeviation,
    profileOwnerUser,
    isAuthorizedToCustomize,
  };
};

export default connect(mapStateToProps);
